// 원본 xlsx 를 통째로 다시 쓰지 않고, 시트 XML 의 셀만 직접 고쳐 넣는 저장기.
// 차트·서식·다른 탭은 그대로 두고, 차트 범위(예: $C$3:$C$35)는 새 마지막 줄까지 늘린다.
(function (root) {
  const NS = "http://schemas.openxmlformats.org/spreadsheetml/2006/main";
  const RNS = "http://schemas.openxmlformats.org/officeDocument/2006/relationships";

  const colLetter = (n) => { let s = ""; while (n > 0) { const m = (n - 1) % 26; s = String.fromCharCode(65 + m) + s; n = Math.floor((n - 1) / 26); } return s; };
  const colIndex = (ref) => ref.replace(/\d+/g, "").split("").reduce((a, ch) => a * 26 + ch.charCodeAt(0) - 64, 0);
  const dirOf = (p) => p.slice(0, p.lastIndexOf("/") + 1);
  const resolve = (base, target) => {
    if (target.startsWith("/")) return target.slice(1);
    const parts = (dirOf(base) + target).split("/"); const out = [];
    parts.forEach((x) => { if (x === "..") out.pop(); else if (x !== "." && x !== "") out.push(x); });
    return out.join("/");
  };
  const relsPath = (p) => dirOf(p) + "_rels/" + p.slice(p.lastIndexOf("/") + 1) + ".rels";

  async function readRels(zip, path, P) {
    const f = zip.file(relsPath(path)); if (!f) return {};
    const doc = new P().parseFromString(await f.async("string"), "text/xml");
    const map = {};
    Array.from(doc.getElementsByTagName("Relationship")).forEach((r) => { map[r.getAttribute("Id")] = { target: resolve(path, r.getAttribute("Target")), type: r.getAttribute("Type") }; });
    return map;
  }

  // plan = { [sheetName]: { rows: [{ r, cells: [{ col, kind, v }] }], styleFromRow, oldLast, newLast } }
  async function write(bytes, plan, deps) {
    const { JSZip, DOMParser: P, XMLSerializer: S } = deps;
    const zip = await JSZip.loadAsync(bytes);
    const wbPath = "xl/workbook.xml";
    const wbDoc = new P().parseFromString(await zip.file(wbPath).async("string"), "text/xml");
    const wbRels = await readRels(zip, wbPath, P);
    const sheets = Array.from(wbDoc.getElementsByTagName("sheet"));
    for (const sh of sheets) {
      const name = sh.getAttribute("name");
      const p = plan[name]; if (!p || !p.rows.length) continue;
      const rid = sh.getAttributeNS(RNS, "id") || sh.getAttribute("r:id");
      const path = wbRels[rid].target;
      const doc = new P().parseFromString(await zip.file(path).async("string"), "text/xml");
      const sheetData = doc.getElementsByTagNameNS(NS, "sheetData")[0];
      const rowEls = {}; Array.from(sheetData.getElementsByTagNameNS(NS, "row")).forEach((e) => { rowEls[+e.getAttribute("r")] = e; });
      // 서식은 원래 마지막 데이터 줄의 같은 열 셀 서식(s)을 그대로
      const styleOf = {};
      const sr = rowEls[p.styleFromRow];
      if (sr) Array.from(sr.getElementsByTagNameNS(NS, "c")).forEach((c) => { styleOf[colIndex(c.getAttribute("r"))] = c.getAttribute("s"); });
      for (const row of p.rows) {
        let re = rowEls[row.r];
        if (!re) {
          re = doc.createElementNS(NS, "row"); re.setAttribute("r", String(row.r));
          const after = Object.keys(rowEls).map(Number).filter((n) => n > row.r).sort((a, b) => a - b)[0];
          sheetData.insertBefore(re, after ? rowEls[after] : null);
          rowEls[row.r] = re;
          if (sr && sr.getAttribute("ht")) { re.setAttribute("ht", sr.getAttribute("ht")); re.setAttribute("customHeight", "1"); }
        }
        for (const cell of row.cells) {
          const ref = colLetter(cell.col) + row.r;
          let ce = Array.from(re.getElementsByTagNameNS(NS, "c")).find((c) => c.getAttribute("r") === ref);
          if (!ce) {
            ce = doc.createElementNS(NS, "c"); ce.setAttribute("r", ref);
            const next = Array.from(re.getElementsByTagNameNS(NS, "c")).find((c) => colIndex(c.getAttribute("r")) > cell.col);
            re.insertBefore(ce, next || null);
          }
          while (ce.firstChild) ce.removeChild(ce.firstChild);
          ce.removeAttribute("t");
          if (styleOf[cell.col] !== undefined && styleOf[cell.col] !== null) ce.setAttribute("s", styleOf[cell.col]);
          if (cell.v === null || cell.v === undefined || cell.v === "") continue;
          if (cell.kind === "formula") {
            const f = doc.createElementNS(NS, "f"); f.appendChild(doc.createTextNode(cell.v)); ce.appendChild(f);
          } else if (cell.kind === "string") {
            ce.setAttribute("t", "inlineStr");
            const is = doc.createElementNS(NS, "is"), t = doc.createElementNS(NS, "t");
            t.appendChild(doc.createTextNode(String(cell.v))); is.appendChild(t); ce.appendChild(is);
          } else {
            const v = doc.createElementNS(NS, "v"); v.appendChild(doc.createTextNode(String(cell.v))); ce.appendChild(v);
          }
        }
      }
      zip.file(path, new S().serializeToString(doc));
      // 이 탭의 차트: 범위 끝 줄을 새 마지막 줄로, 캐시는 지워서 엑셀이 다시 읽게
      const sRels = await readRels(zip, path, P);
      for (const d of Object.values(sRels).filter((x) => /\/drawing$/.test(x.type))) {
        const dRels = await readRels(zip, d.target, P);
        for (const c of Object.values(dRels).filter((x) => /\/chart$/.test(x.type))) {
          let xml = await zip.file(c.target).async("string");
          const esc = name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
          const re = new RegExp("(<c:f>'?" + esc + "'?!\\$[A-Z]+\\$\\d+:\\$[A-Z]+\\$)(\\d+)(</c:f>)", "g");
          xml = xml.replace(re, (m, a, n, b) => (Number(n) === p.oldLast ? a + p.newLast + b : m));
          xml = xml.replace(/<c:numCache>[\s\S]*?<\/c:numCache>/g, "").replace(/<c:strCache>[\s\S]*?<\/c:strCache>/g, "");
          zip.file(c.target, xml);
        }
      }
    }
    // 열 때 수식 다시 계산
    let calc = wbDoc.getElementsByTagNameNS(NS, "calcPr")[0];
    if (!calc) { calc = wbDoc.createElementNS(NS, "calcPr"); wbDoc.documentElement.appendChild(calc); }
    calc.setAttribute("fullCalcOnLoad", "1");
    zip.file(wbPath, new S().serializeToString(wbDoc));
    return zip.generateAsync({ type: deps.outType || "uint8array", compression: "DEFLATE" });
  }

  const api = { write };
  if (typeof module !== "undefined") module.exports = api; else root.XWrite = api;
})(this);
